export default "__VITE_ASSET__f7aca961__"